export const AiMessageTypeEnum = Object.freeze({
    AI: 0,
    HUMAN: 1,
});